//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    props:{
      loadType:{
        type: String,
        required: false
      }
    },
    
  }



// WEBPACK FOOTER //
// ./src/components/loading.vue